import { ReactComponent as ChevronImg } from "assets/images/chevron.svg";

export const Chevron = (props) => {
  return (
    <ChevronImg
      width={24}
      height={26}
      style={{ color: "#FFFFFF" }}
      {...props}
    />
  );
};
